import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  deleteBtn: {
    padding: 0
  }
}));

const style = {
  border: '1px dashed rgba(196, 196, 196, 1)',
  borderRadius: '4px',
  padding: '10.5px 14px',
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontSize: '16px',
  marginBottom: '.5rem',
  backgroundColor: 'white',
  cursor: 'move',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};

const ItemTypes = {
  CARD: 'card',
};

export default ({ id, text, index, moveCard, deleteCard }) => {
  const ref = useRef(null);

  const classes = useStyles();

  const [, drop] = useDrop({
    accept: ItemTypes.CARD,
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.CARD, id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <div ref={ref} style={{ ...style, opacity }}>
      <span>{text}</span>
      <Tooltip title="Delete" arrow placement="top">
        <IconButton
          className={classes.deleteBtn}
          aria-label="delete"
          onClick={() => deleteCard(index)}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};
